import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-6 text-center" data-id="element-0" data-mp="31ayqs2ygxpzt">
    <span aria-hidden="true" className="gold-rule mx-auto block h-px w-24" data-id="element-1" data-mp="31cjpm4rtfv3h" />
    <p className="mt-5 font-serif text-2xl font-semibold italic leading-relaxed text-brand-violetLight md:text-3xl" data-id="element-2" data-mp="2wi5mthatqlos">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen bg-brand-surface font-sans text-brand-text selection:bg-brand-gold/30 selection:text-white" data-id="element-3" data-mp="3ijxsv0nzqion">
      <UrgencyBanner data-id="element-4" data-mp="3mkrcviybbdc9" />
      <Hero data-id="element-5" data-mp="3mjzsl4a6121a" />
      <PackContents data-id="element-6" data-mp="3mjq3rk0ux0x6" />
      <InitialTestimonials data-id="element-7" data-mp="3mj6lu3b7icj5" />
      <PainPoints data-id="element-8" data-mp="3rbrcwx2qabiz" />
      <Pricing data-id="element-9" data-mp="3rdki07xp0nov" />
      <MoreTestimonials data-id="element-10" data-mp="3rcsulke91w9o" />
      <Guarantee data-id="element-11" data-mp="3relv0hy9rk98" />
      <FAQ data-id="element-12" data-mp="5orh0l86u6j" />
      <TransitionPhrase data-id="element-13" data-mp="6htjo98ovic" />
      <EmotionalClose data-id="element-14" data-mp="4n6o4eeqtbm" />
      <Footer data-id="element-15" data-mp="82ld64660ci" />
      <FloatingNotification data-id="element-16" data-mp="7sxbo2oq39g" />
    </div>;
}